module.exports = __webpack_public_path__ + "static/in-cold-blood-ab93ff3f04532fff2c6a40417ce66405.jpg";